var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _image, _image2, _image3, _image4, _image5, _image6, _image7, _image8, _image9, _image10, _image11, _image12, _image13, _image14, _image15, _image16, _image17, _image18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlasvordachTrave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 800 600",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    space: "preserve",
    serif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Glasvordach Trave"
  }, /*#__PURE__*/React.createElement("g", {
    id: "T\\xFCr",
    transform: "matrix(1.02241,0,0,1.15763,123.393,-117.168)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.61685e-18,1.30381,-1.45151,-3.27172e-18,462.458,462.225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-89.734,118.731L120.636,118.49L120.636,89.648L-91.794,89.648L-89.734,118.731Z",
    style: {
      fill: "rgb(179,178,178)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.44939,-6.92115e-18,5.98671e-18,-1.29862,39.7616,313.178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-235.891L173.541,-235.891L172.789,-24.123L-0,0.344L0,-235.891Z",
    style: {
      fill: "rgb(112,111,111)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1.25164,-1.45151,0,210.757,197.779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.759,117.805L92.199,117.805L117.818,-54.676L115.659,-83.759L83.759,117.805Z",
    style: {
      fill: "rgb(135,135,135)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Trave",
    transform: "matrix(1.36064,0,0,1.36064,7.66823,-56.712)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-7.6718e-08,23.1846,23.1397,-3.90799e-14,361.431,244.954)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0,
    rx: 0.574,
    ry: 0.413
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.35368e-17,0.0317613,0.0316999,1.05099e-10,-8.76759,-15.8631)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image2",
    x: 505.064,
    y: 280.228,
    width: "26.005px",
    height: "36.211px",
    transform: "matrix(0.96313,0,0,0.978667,0,0)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.45664e-08,23.1852,23.1404,6.21725e-14,361.431,298.176)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0,
    rx: 0.574,
    ry: 0.413
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-8.51674e-17,0.0317604,0.031699,-8.84467e-11,-11.0629,-15.8626)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image2",
    x: 505.064,
    y: 354.224,
    width: "26.005px",
    height: "36.211px",
    transform: "matrix(0.96313,0,0,0.978667,0,0)"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-4.36627e-09,22.9897,22.9452,-8.88178e-15,87.6246,191.548)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0,
    rx: 0.579,
    ry: 0.406
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23746e-17,0.0320306,0.0319687,6.08335e-12,-6.51893,-4.06448)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image5",
    x: 117.097,
    y: 205.852,
    width: "25.36px",
    height: "36.209px",
    transform: "matrix(0.975368,0,0,0.97863,0,0)"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.63441e-08,22.9903,22.9459,-1.24345e-14,87.6241,259.408)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0,
    rx: 0.579,
    ry: 0.406
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.73235e-17,0.0320297,0.0319678,-9.24294e-11,-9.47042,-4.06434)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image7",
    x: 117.097,
    y: 300.201,
    width: "25.36px",
    height: "36.209px",
    transform: "matrix(0.975368,0,0,0.97863,0,0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.665294,0.664007,0,347.628,352.081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.182,-177.913L318.557,-177.913L178.197,315.182L174.538,315.182L315.182,-177.913Z",
    style: {
      fill: "rgb(139,186,211)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.648134,-0.144599,0.144319,-0.64939,37.706,118.948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-565.588,-65.777L6.44,-65.777L7.235,-62.208L-564.793,-62.208L-565.588,-65.777Z",
    style: {
      fill: "rgb(65,138,168)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.661441,-0.0584363,0.0583233,0.662723,25.1253,167.308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.44,-13.634L310.176,-13.634L309.879,-10.272L-0.761,-9.991L-0.44,-13.634Z",
    style: {
      fill: "rgb(65,138,168)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.665294,0.664007,0,480.8,319.705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.624,-129.532L118.281,-129.532L129.532,114.624L125.876,114.624L114.624,-129.532Z",
    style: {
      fill: "rgb(177,198,209)",
      fillRule: "nonzero"
    }
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(532.872,0,0,533.905,24.0411,192.921)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.00137922,-0,-0,0.00137656,-0.0556923,-0.283273)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image8",
    x: 40,
    y: 137,
    width: "726px",
    height: "138px"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.87849,-7.92362,7.9083,2.88407,134.245,178.243)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.402,-0.879C0.262,-1.135 0.146,-1.259 0.083,-1.236L-0,-1.205L0.03,-0.862C0.085,-0.386 0.353,0.414 0.619,0.884L0.854,1.271L0.937,1.24C1,1.217 1.004,1.098 0.998,0.888C0.961,0.598 0.858,0.213 0.724,-0.155C0.628,-0.419 0.516,-0.674 0.402,-0.879Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0298693,0.082062,-0.0819033,0.0298115,9.53371,-21.1579)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image10",
    x: 177.431,
    y: 182.265,
    width: "29.987px",
    height: "5.84px",
    transform: "matrix(0.99957,0,0,0.973304,0,0)"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.19972,-8.8082,8.79116,3.20593,203.361,173.518)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.435,-0.691C0.282,-0.997 0.145,-1.138 0.07,-1.111L-0.005,-1.084L0.033,-0.864C0.068,-0.473 0.321,0.221 0.581,0.7L0.871,1.147L0.946,1.12C0.983,1.106 1,1.036 0.99,0.891C0.971,0.685 0.892,0.394 0.782,0.092C0.683,-0.177 0.561,-0.456 0.435,-0.691Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0268688,0.0738214,-0.0736787,0.0268169,5.57606,-25.8031)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image12",
    x: 275.883,
    y: 176.352,
    width: "30.495px",
    height: "5.798px",
    transform: "matrix(0.983698,0,0,0.966354,0,0)"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.80345,-7.71742,7.70249,2.80888,134.474,178.859)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.367,-0.916C0.086,-1.42 -0.079,-1.408 -0.015,-0.898C0.042,-0.41 0.316,0.412 0.589,0.894C0.87,1.399 1.035,1.387 0.978,0.898C0.941,0.601 0.835,0.206 0.697,-0.173C0.598,-0.443 0.484,-0.705 0.367,-0.916Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0306662,0.0842556,-0.0840926,0.0306069,9.84972,-21.7752)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image14",
    x: 182.344,
    y: 183.577,
    width: "30.142px",
    height: "5.84px",
    transform: "matrix(0.972328,0,0,0.973277,0,0)"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.11407,-8.57234,8.55576,3.1201,203.609,174.1)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.421,-0.73C0.154,-1.222 -0.049,-1.301 -0.012,-0.9C0.025,-0.498 0.265,0.222 0.551,0.707C0.837,1.193 1.021,1.279 0.991,0.896C0.97,0.676 0.889,0.359 0.771,0.035C0.674,-0.231 0.553,-0.502 0.421,-0.73Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0276082,0.0758524,-0.0757057,0.0275548,5.78006,-26.5604)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image16",
    x: 276.643,
    y: 191.68,
    width: "30.419px",
    height: "6.257px",
    transform: "matrix(0.981245,0,0,0.893852,0,0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.03437,0,0,3.04025,134.275,184.873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.012,-3.201L-0.012,3.262L0.48,3.262C0.726,3.262 0.972,3.201 0.972,3.201L0.972,-3.201C0.972,-3.201 0.788,-3.263 0.48,-3.263C0.234,-3.263 -0.012,-3.201 -0.012,-3.201Z",
    style: {
      fill: "url(#_Linear17)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.0353,0,0,3.04118,203.515,179.728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.005,-3.231L0.005,3.292L0.497,3.292C0.744,3.292 0.99,3.23 0.99,3.23L0.99,-3.169C0.99,-3.231 0.806,-3.293 0.497,-3.293C0.251,-3.293 0.005,-3.231 0.005,-3.231Z",
    style: {
      fill: "url(#_Linear18)",
      fillRule: "nonzero"
    }
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.23298,-8.78896,8.77196,-1.23537,158.039,198.026)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.946,7.853L1.001,-7.683C1.021,-7.978 0.869,-8.106 0.597,-8.144C0.347,-8.179 0.138,-8.06 0.121,-7.785L0.007,7.721C-0.028,7.971 0.166,8.105 0.437,8.143C0.733,8.185 0.911,8.115 0.942,7.894C0.944,7.881 0.946,7.867 0.946,7.853Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip19)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0115485,0.0821607,-0.0820018,-0.0115261,20.0161,-15.8454)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image20",
    x: 124.708,
    y: 192.363,
    width: "194.668px",
    height: "36.198px",
    transform: "matrix(0.998297,0,0,0.978311,0,0)"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.80385,5.44311,-5.43258,3.81122,145.653,227.668)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.196,-10.035L0.004,10.321C0.011,10.704 0.147,10.903 0.424,11.097C0.701,11.29 0.978,11.14 0.968,10.859L0.997,-10.884C0.918,-11.214 0.586,-11.035 0.408,-10.781C0.214,-10.504 0.161,-10.232 0.196,-10.035Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip21)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0635629,-0.0907792,0.0906036,0.06344,-36.0126,2.63256)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image22",
    x: 126.699,
    y: 201.865,
    width: "166.104px",
    height: "117.014px",
    transform: "matrix(0.994634,0,0,0.991645,0,0)"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.16665,-8.31773,8.30165,-1.16891,226.534,188.374)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.99,0.113C1.009,-0.019 0.91,-0.281 0.557,-0.33C0.252,-0.396 0.028,-0.247 -0.003,-0.026C-0.012,0.197 0.216,0.342 0.48,0.379C0.772,0.42 0.965,0.307 0.988,0.143C0.989,0.133 0.99,0.123 0.99,0.113Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip23)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0122005,0.086816,-0.086648,-0.0121769,21.1489,-24.9947)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image24",
    x: 343.563,
    y: 196.72,
    width: "8.154px",
    height: "11.48px",
    transform: "matrix(0.905985,0,0,0.956642,0,0)"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.374,-6.53511,6.52247,2.3786,410.683,235.603)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.369,-0.881C0.217,-1.141 0.12,-1.249 0.045,-1.222L-0.031,-1.194L0.029,-0.872C0.093,-0.38 0.344,0.387 0.604,0.866L0.836,1.268L0.912,1.24C0.963,1.222 0.976,1.102 0.953,0.882C0.914,0.584 0.803,0.175 0.664,-0.206C0.574,-0.455 0.471,-0.693 0.369,-0.881Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0362147,0.0994984,-0.099306,0.0361447,5.68848,-65.8989)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image26",
    x: 563.637,
    y: 288.894,
    width: "24.651px",
    height: "4.453px",
    transform: "matrix(0.986027,0,0,0.890572,0,0)"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.63845,-7.26326,7.24921,2.64356,474.584,233.999)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.45,-0.71C0.266,-1.004 0.14,-1.139 0.072,-1.114L0.003,-1.089L0.032,-0.868C0.074,-0.47 0.331,0.235 0.581,0.71L0.86,1.124L0.951,1.091C1.005,1.097 1.003,1.021 0.999,0.867C0.98,0.657 0.898,0.34 0.78,0.015C0.688,-0.238 0.574,-0.496 0.45,-0.71Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip27)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0325835,0.0895241,-0.089351,0.0325205,2.09077,-67.0054)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image28",
    x: 643.88,
    y: 304.153,
    width: "24.953px",
    height: "5.011px",
    transform: "matrix(0.998131,0,0,0.83518,0,0)"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.3121,-6.36491,6.3526,2.31658,410.811,236.082)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.387,-0.928C0.12,-1.419 -0.055,-1.414 0.012,-0.909C0.078,-0.404 0.335,0.384 0.602,0.875C0.879,1.392 1.053,1.387 0.987,0.882C0.947,0.576 0.833,0.157 0.69,-0.235C0.597,-0.491 0.492,-0.735 0.387,-0.928Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip29)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0371822,0.10216,-0.101962,0.0371103,5.90141,-67.7032)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image30",
    x: 560.177,
    y: 273.838,
    width: "24.799px",
    height: "4.707px",
    transform: "matrix(0.991966,0,0,0.941402,0,0)"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.56837,-7.0701,7.05643,2.57335,475.016,234.568)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.429,-0.753C0.14,-1.256 -0.043,-1.322 -0.009,-0.937C0.025,-0.553 0.266,0.18 0.555,0.684C0.835,1.164 1.035,1.277 0.992,0.869C0.973,0.653 0.887,0.319 0.764,-0.016C0.669,-0.279 0.552,-0.542 0.429,-0.753Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip31)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0334746,0.0919692,-0.0917913,0.0334098,2.19846,-68.9156)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image32",
    x: 662.497,
    y: 299.046,
    width: "25.227px",
    height: "5.117px",
    transform: "matrix(0.970256,0,0,0.852841,0,0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.5562,0,0,2.56116,410.609,241.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.461,-3.237C0.168,-3.237 -0.051,-3.164 -0.051,-3.164L-0.051,3.266L0.461,3.266C0.753,3.266 0.972,3.193 0.972,3.193L0.972,-3.164C0.972,-3.215 0.863,-3.267 0.695,-3.267C0.626,-3.267 0.546,-3.258 0.461,-3.237Z",
    style: {
      fill: "url(#_Linear33)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.5562,0,0,2.56116,474.628,239.424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.034,-3.179L-0.034,3.251L0.478,3.251C0.771,3.251 0.99,3.178 0.99,3.178L0.99,-3.179C0.99,-3.179 0.771,-3.252 0.478,-3.252C0.186,-3.252 -0.034,-3.179 -0.034,-3.179Z",
    style: {
      fill: "url(#_Linear34)",
      fillRule: "nonzero"
    }
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.705626,-7.34012,7.32592,-0.706994,428.408,254.231)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.006,9.071C1.007,9.055 1.008,9.038 1.008,9.02L0.994,-8.827C1.003,-9.184 0.838,-9.327 0.583,-9.326C0.305,-9.353 0.088,-9.221 0.082,-8.89L0.023,8.926C-0.004,9.204 0.212,9.352 0.489,9.378C0.797,9.408 0.982,9.314 1.006,9.072C1.006,9.072 1.006,9.072 1.006,9.071Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.00957407,0.0993995,-0.0992073,-0.00955556,34.3455,-55.9396)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image36",
    x: 498.184,
    y: 275.246,
    width: "186.565px",
    height: "26.528px",
    transform: "matrix(0.997676,0,0,0.982512,0,0)"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.4669,4.6488,-4.63981,2.47168,418.75,276.366)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.146,-11.625L-0.003,12.127C0.004,12.492 0.092,12.781 0.439,12.885C0.738,13.004 0.997,12.819 0.989,12.533L0.954,-12.766C0.96,-13.004 0.573,-12.807 0.392,-12.541C0.371,-12.51 0.351,-12.477 0.333,-12.444C0.185,-12.164 0.152,-11.838 0.146,-11.625Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip37)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.065658,-0.123492,0.123253,0.065531,-77.2706,50.3829)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image38",
    x: 499.819,
    y: 281.049,
    width: "164.224px",
    height: "88.536px",
    transform: "matrix(0.995294,0,0,0.994785,0,0)"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.01214,-7.21665,7.20269,-1.0141,494.993,247.836)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.983,0.1C0.997,-0.002 0.902,-0.249 0.546,-0.299C0.241,-0.342 0.016,-0.218 -0.009,-0.04C-0.012,0.167 0.207,0.276 0.486,0.315C0.793,0.358 0.962,0.27 0.981,0.132C0.983,0.122 0.983,0.111 0.983,0.1Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip39)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.014061,0.100062,-0.0998687,-0.0140338,37.5915,-64.2234)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image40",
    x: 777.482,
    y: 271.811,
    width: "6.1px",
    height: "9.959px",
    transform: "matrix(0.871392,0,0,0.995851,0,0)"
  }))))))), /*#__PURE__*/React.createElement("defs", null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "_Image2",
    width: "27px",
    height: "37px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAlCAYAAACzpJKIAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAA0klEQVRIid2WWQ6DMAxEx6Pc/zC5YPtT0oWQ4Djjj46EBIrw8zIyWK31gYnMrF0ku/ejs+OeWaApbCfIzFBmoFFgD4hkvzIFqNtGFegEk4I+26gGNYN4A6+eFe/LkSSKJ3C0WmaBzOwNU4MaLAVEjme2O4muG1XVutsYbOufWv/WzHYlUSKBvdUyC9TcmOXINOtPN8guo5zcqDLK0I0q0Os5DbS+Qbygr5mpVxWA+cx2JHGorAb2ggBoN8ivZBukJ8nH80qXG2TVKCOFf7/vggDgCe/xETUXuBbZAAAAAElFTkSuQmCC"
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    id: "_Image5",
    width: "26px",
    height: "37px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAlCAYAAABcZvm2AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAuUlEQVRIib3SWw6DMBBDUdvq/heTDbY/aFogoXmMg4QA8XE0N8NSyht/LpKQBJJx/353vW9BpGcoC3mcKBNpQtlIFbIg1zNyIaeJnEhAdkSCdiDH04+QxCsL6UrnRkjez8iVTjuQmMiO1NbbgSynG/q3BZlNN7XeO5DhdNPISLoVpDvdKtKVLgMJyI5I7XSZSDNdNlJNZ0Gu6VwIgG86J3KCnEhAbgTA3HqPIs102Ug1nQO5pXMhAPABpxMQ3lN2t7QAAAAASUVORK5CYII="
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    id: "_Image7",
    width: "26px",
    height: "37px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAlCAYAAABcZvm2AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAvElEQVRIib3VUQ6EIAyE4enE+x+GC+4+uCGi4Bbo1MSI8eELf0m0UsoHfy4zA0mYWb2v7651CkK+Q1HI644ikSEUjXQhCXKfkQppdqREKiRHSDAD+T31iJmdO5IjJI4IxJUuA3nMSIU0M5IiveOtQLbTTX1LQVbTLR3vDGQ63TIyk24HcafbRVzpIpAKyRFynC4SGaaLRrrpJMg9nQoB4PuV7yINpEQqpEYArB3vWWSYLhrpplMgj3QqBAC+pjUQ3ohqVfYAAAAASUVORK5CYII="
  })), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    id: "_Image8",
    width: "726px",
    height: "138px",
    xlinkHref: "data:image/png;base64,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"
  })), _image5 || (_image5 = /*#__PURE__*/React.createElement("image", {
    id: "_Image10",
    width: "30px",
    height: "6px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAGCAYAAADUtS5UAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAoElEQVQoka2RsQ6DMAwFz8hCZub/N36PBYkAgsYdqrQQ0qpUzRLrDb6XnHRd5yIgIogIIM855cfskedZXdeYGU3TnO6qqtiftm1FY7wdFrwWlsq8LzLPM8uyMAxDEW5mmBkAfd+7xhgvQUu/khcJIRBCQFVPBdKcgclekiC/qVjXlW3bGMfxpELdHXf/E/Q7FWaG7qWnEiXo5+yaimmauANGqEJJ6XHBkgAAAABJRU5ErkJggg=="
  })), _image6 || (_image6 = /*#__PURE__*/React.createElement("image", {
    id: "_Image12",
    width: "31px",
    height: "6px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAGCAYAAAA7d0VqAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAArElEQVQokaWRSw7DIAxEnyMSc/8zNDdMFMjPXaAGS6Fq1bLxWCC/8SDj+DAQREBEKLrdVy0Al/Z3qoqqEmO86kurKv6E8zzdUENEMPsdnlIipcQ0TTcTvvZ9X+BtYDuJ8q70XntjIrDvxnEcLMtCCOGWQoyxwu/AutnnJO7GvJl1Xdm2jXmeGYbhMtCEl0FVf5eEvf0in1LOmZwzXdcRAMwMsAbQmmb+TeLFfAJvaVYbx9MGlgAAAABJRU5ErkJggg=="
  })), _image7 || (_image7 = /*#__PURE__*/React.createElement("image", {
    id: "_Image14",
    width: "31px",
    height: "6px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAGCAYAAAA7d0VqAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAX0lEQVQoka2SSwrAMAgF54n3P1PulRi7CyXQkqYRXCjyHD8qpaSZIQkzG/43nnOSmM1rrVtiuwB3kNH8BMDXem+tvQrsTrei4QCZSUQQEUfuvQrs8xP03gEGyIn1PsUXj0YeastfOlsAAAAASUVORK5CYII="
  })), _image8 || (_image8 = /*#__PURE__*/React.createElement("image", {
    id: "_Image16",
    width: "31px",
    height: "7px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAHCAYAAADwK5bPAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAaElEQVQoka2SQQ4AIQgDW8P/P+WzVLonEw+uq6xcINC0yQTmnEUSKSX0Ps6r3ey20pHEWFZK2TJ427l7SAcA1lrbNrhNw2qtYYO/NKbhXwaze4SGSYIkuPsV7Cc0bPw+Seg/cBoUofEAJPQ8gIxyOCcAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear17",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,-0.00049)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(178,178,178)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "rgb(157,157,156)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(178,178,178)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear18",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,-0.00086)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(178,178,178)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "rgb(157,157,156)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(178,178,178)",
      stopOpacity: 1
    }
  })), _image9 || (_image9 = /*#__PURE__*/React.createElement("image", {
    id: "_Image20",
    width: "195px",
    height: "37px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMMAAAAlCAYAAAD/Yl01AAAACXBIWXMAAA7EAAAOxAGVKw4bAAADuElEQVR4nO2cXW6DMAyAnUB7gr7sUjtsj9a9TJpI9tCmCSQE2/mhtP6kiMjKthY+hwAeCgThIFyvV0sZPwwDjOO4uXV91eqDCwIHjvBLqTHip7aSDEJ3SoRfSp2TfGuMMWbWJBmEJlCF11pXmd2XY5bCr7dJkkHg01J4ivh44dcTwRgrySBsQ5HeCU+RGTO2XHhJBgFJifCUdXxubFvhc4lgJBk+Darwte7ShFtr7Y7Sz/+2tQamycclGd4MrvA1xe8h/F1kXMyYedzH/FnBWkmGQ1IqfA3xKcJTxE1LG8fC+HZsegofxpRSoJQCrfW93/KgCXxqCV9yX95aC9baYAbFzLa02JbILs6NAcBDeg1aq0VfP5Lh0W92NIVNOMLXvkvjhJ8vG0KpfDLwZuVY0NoNICd8Rv5HHx5pIMnQGIrwSqmii9O1saHw4TIhFD6O0Wbg1s3tn1Lhs/uffZSFJzWEL13Hp4S/N3+RGMfCZFjG+je3f2br+Iz883H3huX7+zsaLMmAhCt8Se3McoxSKiNTfOtwLrhNxPongts/S+FTs3kL4bPHjTL43aEK3+IuTV74XCLkZv++ZwW3f15R+OwxrfWLjkIt4UvE5wm/Nvvvc1awFlhrd9ffS/gcb5kMtYXniM8XvtVZISV9Phmstai1+5GEz7H7B+BCrZikrtEx237Cb83+W8ugtWT4POFzvPSH4whPmdUxydFXeHwi+LoaL/w85mU3xszW5Hn5U+PeR/gcu3/wmsJz1/G9hafX1fhkiOtqtoXHXrhiObLwObp8Ke4/ctcUnyv8a9TViPA9qPaFS99cQBF/7We01oTZtjxWt65megrPfcrq+lg+UfgcpJ1RS/iSMoNhGBI1NHalroZWQ5OKtSo7wK7dRfh+RDuq9btpsNv5EsFAeAEZ19DYl6yrEeGPhcLIT53NKcL7doxyArrw6bW762MR4dszuk4oPLd2JjVmKc80TfD397ciff0HR/WF9w/psBeuWET4fRkvl0vx7Umc8FuzP//BkQgv1GD8+vpCiY8Xfq3l6mowyVCeCMvli9b+OUN+HU8THkCkPyLq9/fXrglft/W5JuCWFbg+BRH+vRjpMzw3EXKzP+2agD/Di/DCOuPtdus0+/t4XENjo9jyrkta+PU7NRREeAFgIxlavJsmjMXCaxiGEVVWIMILtRl/fm4ZkeNYGGe9m0YpOJ3OIrzwcjzPDLXfTTOOJzifz6hbkxREeKEV6GsGgLTwNV/V4RDhhT2YJQOACC98Lv+ZP3eeItP1pQAAAABJRU5ErkJggg=="
  })), _image10 || (_image10 = /*#__PURE__*/React.createElement("image", {
    id: "_Image22",
    width: "167px",
    height: "118px",
    xlinkHref: "data:image/png;base64,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"
  })), _image11 || (_image11 = /*#__PURE__*/React.createElement("image", {
    id: "_Image24",
    width: "9px",
    height: "12px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAMCAYAAACwXJejAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAQ0lEQVQYlWN8+/bt/////zP8//+fgYGBAYWGYZbfv39jSKCzKVcEo1l+//6N1xTyFKH7Cq7oz58/eE1BCQKSFdEuMAFY++OSJYlSjQAAAABJRU5ErkJggg=="
  })), _image12 || (_image12 = /*#__PURE__*/React.createElement("image", {
    id: "_Image26",
    width: "25px",
    height: "5px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAFCAYAAACw/UeDAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAhklEQVQYlaVQWwoDIQycVBFJ7n8CL6igCwpN+mEtbKVbaANDAgPzCKWUjIjwGQDR7W1PDiCEEMDML4gImBnOOazxqvcLgyVmz9s2rveOMQZKKZsRMyPGCK+qp2TfDK8at9ZwHA2llJORV1UA+El4DzWbqs52OWeICPz6m5nBbH/Hvw1rrXgAfrg0hdIsDOQAAAAASUVORK5CYII="
  })), _image13 || (_image13 = /*#__PURE__*/React.createElement("image", {
    id: "_Image28",
    width: "25px",
    height: "6px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAGCAYAAAA2aTUtAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAkElEQVQokY2R0QrDIAxFT6gI9v9/oX+Y6qTO7EGwc2s3hYuRC/ckUbZtMxFBBNrdBDK8T9G9ZVkIIbCuKyGEoW4Z7bhaK/MQBs/MUFX2fe+QT6hzDlfr87LjGci7YoyklPDef4POSf5BxknNrteZ84OcM6raYbeQMYiJJsY/O46DUgqqigMwM8zsR9AMhFvvBdCdPAwNZblqAAAAAElFTkSuQmCC"
  })), _image14 || (_image14 = /*#__PURE__*/React.createElement("image", {
    id: "_Image30",
    width: "25px",
    height: "5px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAFCAYAAACw/UeDAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAWUlEQVQYlZWQUQrAMAhDo/X+d/Jahbh9FbZWu07IzyMaibj7paqY1VpbWMVnJiJ4jvXeUzPJ9FDGK6+qvkO+zCehFTOSGPrz4amfJGz0FhGICABYFnZVnYTeE0dG9ZpYxr0AAAAASUVORK5CYII="
  })), _image15 || (_image15 = /*#__PURE__*/React.createElement("image", {
    id: "_Image32",
    width: "26px",
    height: "6px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAGCAYAAADdXo4uAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAWElEQVQokaWRQQ6AQAgDKfD/T/GsheppEz2sLkrCrWXSgog4VFUAiKpu7a72Oj7G+HVsas1s6QGwBnXBJB89npntBF9Se1VJVbXr6IJ9PoukkLyJ3+rogE9L8SEuQROdLgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear33",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,-0.00046)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(178,178,178)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "rgb(157,157,156)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(178,178,178)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear34",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,-0.00078)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(178,178,178)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "rgb(157,157,156)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(178,178,178)",
      stopOpacity: 1
    }
  })), _image16 || (_image16 = /*#__PURE__*/React.createElement("image", {
    id: "_Image36",
    width: "187px",
    height: "27px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALsAAAAbCAYAAAAkjP6EAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACr0lEQVR4nO2bUW6rMBBFZ2y//6wsi82KsoIiRfl7BfeDUCAwZGyPjQtzJFS3GDdSTt17rRZBUSrgdrv51DWMMWCtXVzD11HihSoKRU6JP13GGHDO/X6usitRSEgcIm2M7MOz3nvw3qvsyoiEwIgoIun0+WF3fl+v6zrw3kPXda9xB13nybHKfgKkJY6Vljt3lNcT422p+4/Lscr+h8mdh6V2ZmstIOJMWlpkvtQcwVX2ytmz1IVKDwAMaT8Jzpc6VPDpcyp7QUqWutSdmb/71ir4+1hlTyZHHpaID1KlLm68XH8q3Xg/RV5a6mF9RJxfEm/4Edm71IVIL1HqZHZPSurQrL49nktsABHBGFzK/bp3WtlL5OHUc2Gq1NUZD+QED5b3dfVz5/fWOIzsRy11tDTpkaOE1L3EhpB3Kel83lLuGK7XKwL8AdlLl7qUnVnq1zRf8KmEOQSnX9+6uOHySkjMZRfZc+Xh1Pgw/TuK6Vo5dtUwMSnpCpS6TXm3o0WsXqEScxFdVCpKSGXerQsRK8y/KUd5mUrdSi6OJZfEXFjfvFQelpB8q9TVEw/kBM9d6j6xt8AhYKrIqZJyhQeIK3VzabaE3S//vkvtvQdj6HxbstQdCUfdyBkhuKWubdsMglNCSgkeV+qcs1WWuiPhLpdLlp2Zigpt28L393+2XPF5mfNDkbfUGWPZha6fb6LfyDNLzAXv97vn7srTUldP/k05ygsrddyz4iOVuiOBbdt6bqnbNx7ICR4j7zj3XKXuSLjH41Gx4HypvQdSXmMsOBd2VhyDSlw3rmkahuAcOVMETyt1Ibk4BpX4GLimaaLjwd6lbsjEsajE58I1zZdowaNKnbX9P86G5OJYVGJljdfO/llwqtSNEmupU+rGPZ/P1Yjg3D9CXDpWxKASK6X4AWYd97qc/R7yAAAAAElFTkSuQmCC"
  })), _image17 || (_image17 = /*#__PURE__*/React.createElement("image", {
    id: "_Image38",
    width: "165px",
    height: "89px",
    xlinkHref: "data:image/png;base64,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"
  })), _image18 || (_image18 = /*#__PURE__*/React.createElement("image", {
    id: "_Image40",
    width: "7px",
    height: "10px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAKCAYAAAB4zEQNAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAP0lEQVQYlWN88+bN/////zPAMAMDA5zN8uvXL6wSGJJE62RgYEBIohsJl8QmATeWaEkUB/3+/Zt01/7//58BAERFpMM7JDZZAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasvordachTrave);
export default __webpack_public_path__ + "static/media/glasvordach_trave.62771c2e75f0e4c60785614cb93a6c5f.svg";
export { ForwardRef as ReactComponent };